import { motion } from "framer-motion";
import { WhatsappLogo } from "@phosphor-icons/react";

const WHATSAPP = process.env.REACT_APP_WHATSAPP_NUMBER;

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent("Olá! Gostaria de solicitar um orçamento de TI para minha empresa.")}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Falar no WhatsApp"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-black/20"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] whatsapp-ping" aria-hidden="true" />
      <WhatsappLogo size={28} weight="fill" className="relative" />
    </motion.a>
  );
}
